import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBIswRFsBATOyZVo1raQptIvVwHAtkznYs",
  authDomain: "speedy-aileron-416417.firebaseapp.com",
  projectId: "speedy-aileron-416417",
  storageBucket: "speedy-aileron-416417.firebasestorage.app",
  messagingSenderId: "9424223693",
  appId: "1:9424223693:web:e0da21b55f3b685ec49884",
  measurementId: "G-HLW3CKSBLH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);
